<div class="viewport-container py-12">
  <div class="grid grid-flow-dense grid-cols-4 gap-8 lg:gap-x-16">

    <!-- Company Info -->
    <div class="col-span-4 max-w-xl 3xl:col-span-2">
      <a class="flex items-center flex-col w-max" routerLink="/">
        <brand-logo class="h-16"></brand-logo>
      </a>
      <p class="mt-4 text-black leading-relaxed text-justify">
        Designing bespoke green space with your vision at its core. 
        MAPA Garden Designs offers breadth of landscaping services from 
        design-only to full end-to-end design & build for indoor 
        & outdoor spaces in commercial & residential settings. 
      </p>
    </div>

    <div class="grid gap-4 col-start-1 row-start-4 sm:row-start-auto col-span-4 
        3xl:col-span-2 3xl:col-start-1
        text-black">
      <a href="tel:{{contact.phoneNumber.code}} {{contact.phoneNumber.number}}" class="flex gap-4 max-w-max hover:text-primary-800 transition-colors" aria-label="Instagram"
         target="_blank">
        <fa-icon [icon]="icons.faPhone" class="text-lg"></fa-icon>
        <span>{{contact.phoneNumber.code}} {{contact.phoneNumber.number}}</span>
      </a>
      <a href="mailto:{{contact.email}}" class="flex gap-4 max-w-max hover:text-primary-800 transition-colors" aria-label="Instagram"
         target="_blank">
        <fa-icon [icon]="icons.faEnvelope" class="text-lg"></fa-icon>
        <span>{{contact.email}}</span>
      </a>
      <a [href]="contact.social.instagram.link" class="flex gap-4 max-w-max hover:text-pink-500 transition-colors" aria-label="Instagram"
         target="_blank">
        <fa-icon [icon]="icons.faInstagram" class="text-lg"></fa-icon>
        <span>#{{contact.social.instagram.hashtag}}</span>
      </a>
    </div>

    <!-- Quick Links -->
    <div class="col-span-4 sm:col-span-2 3xl:col-span-1 row-start-2 3xl:row-start-auto">
      <h3 class="text-black text-lg font-semibold mb-2 sm:pl-4">quick links</h3>
      <nav>
        <ul class="space-y-2">
          @for(item of footerMenu.quickLinks; track item) {
          <li>
            <a [routerLink]="item.link" class="btn btn-text lowercase">
              {{item.text}}
            </a>
          </li>
          }
        </ul>
      </nav>
    </div>

    <!-- How we Work -->
    <div class="col-span-4 sm:col-span-2 3xl:col-span-1">
      <h3 class="text-black text-lg font-semibold mb-2 sm:pl-4">how we work</h3>
      <nav>
        <ul class="space-y-2">
          @for(item of footerMenu.howWeWork; track item) {
          <li>
            <a [routerLink]="item.link" [fragment]="item.fragment"
               class="btn btn-text lowercase">
              {{item.text}}
            </a>
          </li>
          }
        </ul>
      </nav>
    </div>

  </div>
</div>

<mat-divider></mat-divider>

<!-- Bottom Bar -->

<div class="bg-primary-800 text-white">
  <div class="viewport-container py-4">
    <div class="flex flex-col 3xl:flex-row justify-between items-center gap-4">
      <div class="text-sm text-center">
        © 2025 MAPA Garden Designs. All rights reserved.
      </div>
      <div class="flex gap-6 text-sm">
        @for(link of legalLinks; track link) {
        <a [routerLink]="link.url" class="hover:text-secondary-300 transition-colors">{{link.text}}</a>
        }
      </div>
    </div>
  </div>

</div>